<template>
  <div class="page">
    <!-- phone -->
    <div class="label">手机号</div>
    <div class="input_box">
      <div class="input_tag_box">
        <div class="input_info">
          <input type="text" v-model="phone" placeholder="请输入充值手机号" />
        </div>
        <div class="tag">*点击确定后，请确认头像和昵称</div>
      </div>
      <button class="phone_btn" @click="onComfirm">确定</button>
    </div>
    <div class="user_info" v-if="info.token">
      <img :src="info.avatar" />
      <span>{{ info.nickname }}</span>
    </div>
    <!-- recharge -->
    <div class="recharge_box">
      <div class="label">充值金额</div>
      <div class="recharge_list_box">
        <div class="re_item" :class="{ active: reIndex == item.num }" @click="onRecharge(item)" v-for="(item, index) in rechargeList" :key="index">
          <img src="../../assets/ic_gold.png" alt="" />
          <div>{{ item.num }}金币</div>
          <span>{{ item.num }}元</span>
        </div>
      </div>
      <div class="input_tag_box">
        <div class="input_info">
          <input type="number" v-model="num" @input="onInput" placeholder="请输入充值金额" />
          <span>元</span>
        </div>
        <div class="tag">*1元=1金币，购买金币后不可提现</div>
      </div>
    </div>
    <div class="down_way_box">
      <label class="label">充值方式</label>
      <div class="input_tag_box">
        <div class="down_way">
          <div class="btn" :class="{ active: paytype == 3 }" @click="paytype = 3">
            <span class="ios">微信</span>
          </div>
          <div class="btn" :class="{ active: paytype == 4 }" @click="paytype = 4">
            <span class="android">支付宝</span>
          </div>
        </div>
        <div class="tag">
          *温馨提示：切勿轻信刷单、低价充值等类似得言论，谨防上当受骗
        </div>
      </div>
    </div>
    <button class="recharge_btn" @click="onSubmit">立即充值</button>
    <div class="guidePage" v-if="guideState">
      <span @click="guideState = false">×</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      reIndex: 0,
      phone: "",
      info: {},
      num: "",
      token: "",
      //支付方式
      paytype: 9999,
      payPopup: false,
      wechatImg: "",
      orderNo: "",
      rechargeList: [
        {
          num: "10",
        },
        {
          num: "30",
        },
        {
          num: "50",
        },
        {
          num: "100",
        },
        {
          num: "500",
        },
        {
          num: "1000",
        },
      ],
      guideState: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //在微信中打开
      this.guideState = true;
    }
  },
  mounted() { },
  methods: {
    onPageJump(url) {
      this.$router.push(url);
    },
    onRecharge(item) {
      this.reIndex = item.num;
      this.num = item.num;
    },
    onComfirm() {
      if (!this.phone) {
        this.$prompt("请输入手机号");
        return;
      }
      this.info = {};
      this.$http
        .get("api/v1/web/getUinfo", {
          phone: this.phone,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.info = res.data;
          }
        });
      // this.$prompt('该手机号码不存在');
    },
    onInput() {
      this.reIndex = 9999;
      setTimeout(() => {
        this.num = Math.ceil(this.num);
      }, 500);
    },
    onSubmit() {
      if (!this.phone) {
        this.$prompt("请输入手机号");
        return;
      }
      if (!this.info.token) {
        this.$prompt("请按“确定”，确认用户信息");
        return;
      }
      if (!this.num) {
        this.$prompt("请选择或填写充值金额");
        return;
      }
      if (this.num == 0) {
        this.$prompt("最小充值金额为1");
        return;
      }
      if (this.paytype == 9999) {
        this.$prompt("请选择充值方式");
        return;
      }
      let httpData = {
        token: this.info.token,
        timestamp: this.info.timestamp,
        paytype: this.paytype,
        num: this.num,
        phone: this.phone,
      };
      this.$http.post("api/v1/web/recharge", httpData).then((res) => {
        this.orderNo = res.data.rid;
        if (this.paytype == 1) {
          setTimeout(() => {
            this.onJumpPay(res.data.pay);
            this.onWxPay();
          }, 2000);
        } else {
          this.onJumpPay(res.data.pay);
          setTimeout(() => {
            this.onWxPay();
          }, 2000);
        }
        this.$prompt("发起支付成功");
      });
    },
    onJumpPay(url) {
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.location.href = url;
      } else {
        window.open(url);
      }
    },
    onWxPay() {
      clearInter && clearInterval(clearInter);
      let index = 0;
      clearInter = setInterval(() => {
        index++;
        if (index <= 30 && this.payPopup) {
          this.$http
            .post(
              "api/v1/web/payCall",
              {
                rid: this.orderNo,
              },
              {
                load: false,
              }
            )
            .then((res) => {
              if (res.code == 200) {
                this.$prompt("支付成功");
                setTimeout(() => {
                  this.$router.push("/paySuccess");
                }, 500);
                clearInter && clearInterval(clearInter);
              }
            });
        } else {
          clearInter && clearInterval(clearInter);
          this.onWxPay();
        }
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.page {
  background-color: #ffffff;
  padding: vw(40) vw(30);

  .recharge_btn {
    width: 100%;
    height: vw(80);
    background: #466bfe;
    box-shadow: 0px 2px 4px 0px rgba(80, 100, 236, 0.33);
    border-radius: vw(8);
    font-size: vw(28);
    color: #ffffff;
    margin-top: vw(40);
  }
  .recharge_btn:active {
    transition: all 0.4s;
    background: #143bd7;
  }
  .user_info {
    display: flex;
    align-items: center;
    margin-top: vw(24);
    > img {
      width: vw(90);
      height: vw(90);
      border-radius: 50%;
    }
    > span {
      font-size: vw(28);
      color: #333333;
      margin-left: vw(24);
    }
  }
  .phone_btn {
    width: vw(160);
    height: vw(80);
    background: #466bfe;
    box-shadow: 0px 2px 4px 0px rgba(80, 100, 236, 0.33);
    border-radius: 4px;
    margin-left: vw(30);
    font-size: vw(28);
    color: #ffffff;
  }
  .label {
    width: vw(120);
    font-size: vw(28);
    color: #333333;
    padding-bottom: vw(20);
  }
  .input_box {
    width: 100%;
    display: flex;
  }
  .down_way_box {
    margin-top: vw(60);
    .down_way {
      display: flex;
      margin-top: vw(20);
      .btn {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding: 0 30px;
        width: vw(300);
        height: vw(80);
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #cdced5;
        text-align: center;
        margin-right: vw(40);
        .ios {
          display: flex;
          align-items: center;
          &::before {
            content: "";
            @include bis("../../assets/ic_weixin_c.png");
            margin-right: vw(32);
            width: vw(48);
            height: vw(48);
          }
        }
        .android {
          display: flex;
          align-items: center;
          &::before {
            content: "";
            @include bis("../../assets/ic_zhifubao.png");
            margin-right: vw(32);
            width: vw(48);
            height: vw(48);
          }
        }
        span {
          color: #333333;
          font-size: vw(28);
        }
      }
      // 鼠标悬浮效果
      .btn.active {
        transition: all 0.4s;
        background: #466bfe;
        border-radius: 6px;
        .ios {
          &::before {
            content: "";
            @include bis("../../assets/ic_weixin_white.png");
            margin-right: vw(32);
            width: vw(48);
            height: vw(48);
          }
        }
        .android {
          &::before {
            content: "";
            @include bis("../../assets/ic_zhifubao_white.png");
            margin-right: vw(32);
            width: vw(48);
            height: vw(48);
          }
        }
        span {
          color: #fff;
        }
      }
    }
  }
  .recharge_box {
    margin-top: vw(60);
    .recharge_list_box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: vw(20);
      .re_item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: vw(214);
        height: vw(200);
        background: rgba($color: #375cf7, $alpha: 0.1);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        border: 1px solid rgba($color: #cdced5, $alpha: 0.1);
        margin-right: vw(20);
        margin-bottom: vw(20);
        &:nth-child(3n) {
          margin-right: 0px;
        }
        img {
          width: vw(50);
          height: vw(50);
        }
        div {
          margin-top: 4px;
          font-size: vw(32);
          font-weight: 500;
          color: #365df8;
        }
        span {
          margin-top: 4px;
          font-size: vw(28);
          color: #666666;
        }
      }
      .active {
        border: 1px solid #375cf7;
      }
    }
  }
  .input_tag_box {
    flex: 1;
    .tag {
      margin-top: vw(20);
      font-size: vw(24);
      font-weight: 400;
      color: #999999;
    }
  }
  .input_info {
    height: vw(80);
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cdced5;
    display: flex;
    align-items: center;
    padding: 0 vw(40);
    input {
      height: vw(80);
      background-color: transparent;
      flex: 1;
      border: none;
      font-size: vw(28);
    }
  }
  @font-face {
    font-family: myfont;
    src: url("~@/font/YouSheBiaoTiHei.ttf");
  }
}
.guidePage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  background-image: url("./../../assets/indicate.png");
  background-repeat: no-repeat;
  background-position: vw(50) top;
  background-size: 90% auto;
  z-index: 3;
  span {
    position: absolute;
    bottom: vw(80);
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #fff;
    border-radius: 50%;
    width: vw(80);
    height: vw(80);
    text-align: center;
    line-height: vw(80);
    color: #fff;
    font-size: vw(42);
  }
}
</style>
